import { TableColumn } from '../types';

export const STOCK_SUMMARY_COLUMNS: TableColumn[] = [
  { id: 'sl', label: 'SL NO', minWidth: 60 },
  { id: 'itemCode', label: 'Item Code', minWidth: 100 },
  {
    id: 'itemName',
    label: 'Item Name',
    align: 'left',
    minWidth: 150,
  },
  {
    id: 'unit',
    label: 'Unit',
    align: 'center',
    minWidth: 80,
  },
  {
    id: 'HSN',
    label: 'HSN',
    align: 'center',
    width: '120px',
  },
  {
    id: 'taxability',
    label: 'Taxability',
    align: 'center',
    minWidth: 100,
  },
  {
    id: 'openingStock',
    label: 'Opening stock',
    align: 'center',
    minWidth: 200,
    subColumns: [
      { id: 'openingStockQty', label: 'Qty', align: 'center', minWidth: 80 },
      { id: 'openingStockAmt', label: 'Amt', align: 'right', minWidth: 120 },
    ],
  },
  {
    id: 'inStock',
    label: 'Purchase',
    align: 'center',
    minWidth: 200,
    subColumns: [
      { id: 'inStockQty', label: 'Qty', align: 'center', minWidth: 80 },
      { id: 'inStockAmount', label: 'Amt', align: 'right', minWidth: 120 },
    ],
  },
  {
    id: 'outStock',
    label: 'Sales',
    align: 'center',
    minWidth: 200,
    subColumns: [
      { id: 'outStockQty', label: 'Qty', align: 'center', minWidth: 80 },
      { id: 'outStockAmount', label: 'Sales Amt', align: 'right', minWidth: 120 },
    ],
  },
  {
    id: 'closingStock',
    label: 'Closing Stock',
    align: 'center',
    minWidth: 200,
    subColumns: [
      { id: 'closingStockQty', label: 'Qty', align: 'center', minWidth: 80 },
      { id: 'closingStockAmount', label: 'Amt', align: 'right', minWidth: 120 },
    ],
  },
  {
    id: 'cogs',
    label: 'COGS value',
    align: 'right',
    minWidth: 120,
  },
  {
    id: 'pandl',
    label: 'Profit/Loss',
    align: 'right',
    minWidth: 120,
  },
  {
    id: 'margin',
    label: 'Margin %',
    align: 'right',
    minWidth: 100,
  },
];

export const ITEM_WISE_COLUMNS: TableColumn[] = [
  { id: 'date', label: 'Date', minWidth: 120 },
  { id: 'particular', label: 'Particular', minWidth: 200 },
  {
    id: 'voucher',
    label: 'Voucher No',
    align: 'left',
    minWidth: 130,
  },
  {
    id: 'qty',
    label: 'QTY',
    align: 'right',
    minWidth: 100,
  },
  {
    id: 'costItem',
    label: 'Cost/Item',
    align: 'right',
    minWidth: 120,
  },
  {
    id: 'totalCost',
    label: 'Total Cost',
    align: 'right',
    minWidth: 120,
  },
  {
    id: 'closingStock',
    label: 'Closing Stock',
    align: 'right',
    minWidth: 120,
  },
  {
    id: 'stockAmount',
    label: 'Closing Stock Amount',
    align: 'right',
    minWidth: 150,
  },
  {
    id: 'remark',
    label: 'Remark',
    align: 'left',
    minWidth: 200,
  },
];
